import http from 'plugins/axios';

export default {
  getPairList() {
    return http.get({
      url: '/ta/admin/tenant/symbol/getSymbolList',
      data: { type: 'SPOT' },
    });
  },
  getTpslPage(data) {
    return http.get({
      url: '/ta/admin/order/tpsl/findAll',
      data,
    });
  },
  getTpslStatuses() {
    return http.get({
      url: '/ta/admin/order/tpsl/statuses',
    });
  },
};
